
import Vue from 'vue';
import QoalaTyped from '../../Icons/QoalaTyped.vue';
import { Padder } from '../Spacings';

/**
 * The Header of the Application.
 *
 * This template consist of:
 *
 * - Menu icon
 * - Logo
 * - Right Component
 */
export default Vue.extend({
  name: 'AppBarEntry',
  components: {
    QoalaTyped,
    Padder
  },
  props: {
    /**
     * The logo of the AppBar.<br />
     * The type is VueComponent.
     */
    logo: {
      type: Object,
      default: () => {}
    },
    /**
     * Show component in the right side of sidebar.
     */
    rightComponent: {
      type: Boolean,
      default: false
    },
    /**
     * Show menu icon in the left of the sidebar.
     */
    hideMenu: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleMenuClick() {
      /**
       * Handle when user click the menu if available.
       * @event menu-click
       * @type {function}
       */
      this.$emit('menu-click');
    },
    handleRightClick() {
      /**
       * Handle when user click the right component if available.
       * @event right-click
       * @type {function}
       */
      this.$emit('right-click');
    }
  }
});
